import R from '../R';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';
import EFLaptop from '@/components/UI/svg/river2/Icon/EFLaptop';
import EFPhone from '@/components/UI/svg/river2/Icon/EFPhone';
import EFLight from '@/components/UI/svg/river2/Icon/EFLight';
import EFBlanket from '@/components/UI/svg/river2/Icon/EFBlanket';

const { EFPic } = createEFPic('');
export default function E1() {
    const { useLang, useRouter, useState, useEffect } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('productriver2.river2.details');
    const [open, setOpen] = useState(false);
    const [container, setContainer] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setContainer(document.getElementById('river2_detial_E1'));
        }
    }, []);

    const lists: any[] = [
        {
            icon: <EFPhone />,
            app: t('secE1_list1_app'),
            text: t('secE1_list1_text'),
        },
        {
            icon: <EFLaptop />,
            app: t('secE1_list2_app'),
            text: t('secE1_list2_text'),
        },
        {
            icon: <EFLight />,
            app: t('secE1_list3_app'),
            text: t('secE1_list3_text'),
        },
        {
            icon: <EFBlanket />,
            app: t('secE1_list4_app'),
            text: t('secE1_list4_text'),
        },
    ];

    const imgMap: any = {
        us: ['/media/river2/h5/E1_us.jpg', '/media/river2/h5/E1_us.jpg'],
        au: ['/media/river2/h5/E1_au.jpg', '/media/river2/h5/E1_au.jpg'],
        uk: ['/media/river2/h5/E1_uk.jpg', '/media/river2/h5/E1_uk.jpg'],
        eu: ['/media/river2/h5/E1_eu.jpg', '/media/river2/h5/E1_eu.jpg'],
        sa: ['/media/river2/h5/E1_me-ar.jpg', '/media/river2/h5/E1_me-ar.jpg'],
        de: ['/media/river2/h5/E1_eu.jpg', '/media/river2/h5/E1_eu.jpg'],
        fr: ['/media/river2/h5/E1_eu.jpg', '/media/river2/h5/E1_eu.jpg'],
        es: ['/media/river2/h5/E1_eu.jpg', '/media/river2/h5/E1_eu.jpg'],
        it: ['/media/river2/h5/E1_eu.jpg', '/media/river2/h5/E1_eu.jpg'],
        za: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711699204502/r2p_e1_768_za.jpg',
        ph: 'https://websiteoss.ecoflow.com/upload/image/1751079276763/4-m.jpg',
    };

    return (
        <div className={`${css.E1} river2_detials_E1`} id="river2_detial_E1">
            <div className="content">
                <p className="title">{t('secE1_title')}</p>
                <div className="img-box">
                    {locale === 'ph' ? (
                        <img src={imgMap[locale]} alt={t('secE1_title')} aria-label={t('secE1_title')} />
                    ) : (
                        <EFPic name={imgMap[locale] || imgMap.us} className="fullImgs" alt={t('secE1_title')} aria-label={t('secE1_title')} />
                    )}
                </div>
                <ul className="lists">
                    {lists?.map((list: any, k: number) => (
                        <li className="list" key={k}>
                            <div className="list-icon">{list?.icon}</div>
                            <p className="list-app">{list?.app}</p>
                            <p className="list-text">{list?.text}</p>
                        </li>
                    ))}
                </ul>
                <p className="desc">
                    {t.rich('secE1_desc', {
                        h: (h: string) => <span className="h">{h}</span>,
                    })}
                </p>
                <div className="check-btn" onClick={() => setOpen(true)}>
                    {t('secE1_btn_text')} <span className="plus-icon">+</span>
                </div>
            </div>
            <R open={open} setOpen={setOpen} container={container} />
        </div>
    );
}
